module.exports = __webpack_public_path__ + "static/media/DSC_5595.50cf0a83.jpg";